import Personalization from 'theme/atoms/Personalization'
import * as t from './types'
import * as React from 'react'
import { FetchContentResult } from 'utils/dy-hybrid/endpoints/fetchContent'

const mapDy =
  (prevProps: t.Props) =>
  (config: FetchContentResult<t.DyResponse>): t.Props => {
    const {
      ItemImage1,
      ItemTitle1,
      ItemLink1,
      ItemLinkText1,
      ItemImage2,
      ItemTitle2,
      ItemLink2,
      ItemLinkText2
    } = config.content
    const imageItems = [
      {
        imgSrc: ItemImage1,
        title: ItemTitle1,
        linkLabel: ItemLinkText1,
        link: ItemLink1
      },
      {
        imgSrc: ItemImage2,
        title: ItemTitle2,
        linkLabel: ItemLinkText2,
        link: ItemLink2
      }
    ]

    return {
      __version: prevProps.__version,
      showDefaultDataByControlGroup: prevProps.showDefaultDataByControlGroup,
      gridArea: prevProps.gridArea,
      dySelector: prevProps.dySelector || '',
      imageItems: imageItems,
      eecTracking: prevProps.eecTracking,
      context: { ...prevProps.context }
    }
  }

export default function withDy(
  Component: React.JSXElementConstructor<t.Props>
) {
  return function Wrapper(props: t.Props) {
    if (!props.dySelector) return <Component {...props} />

    return (
      <Personalization<t.Props, t.DyResponse>
        processResponse={mapDy(props)}
        selector={props.dySelector}
        showDefaultDataByControlGroup={props.showDefaultDataByControlGroup}
        shape={[
          'object',
          {
            ItemImage1: 'string',
            ItemTitle1: 'string',
            ItemLink1: 'string',
            ItemLinkText1: 'string',
            ItemImage2: 'string',
            ItemTitle2: 'string',
            ItemLink2: 'string',
            ItemLinkText2: 'string'
          }
        ]}
        initialData={{ ...props }}
        strategy="BLUR"
        render={(data) => <Component {...data} />}
      />
    )
  }
}
